import { usePmsCommLog } from 'app/components/pms-comm-log/usePmsCommLog'
import { PmsCommLogComponent } from 'app/components/pms-comm-log/PmsCommLogComponent'

export default function CommLog() {
  const props = usePmsCommLog()
  return <PmsCommLogComponent {...props} />
}
